module.exports = __webpack_public_path__ + "img/Bg.93f61a46.png";